import Immutable from 'immutable';
import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  inks: Immutable.List<Immutable.Map<string, any>>,
  useScreensFromFile: boolean
} = {
  inks: Immutable.List(),
  useScreensFromFile: false
};

class InksFromFile extends Immutable.Record(Content) {
  static fromJS (json: object): InksFromFile {
    return ClassFactory.createFromJson(json, InksFromFile);
  }
}

export default InksFromFile;
